import { createController, createControllerEndpoint } from '../utils/api'
import { useGlobalProject } from 'src/utils/globals';
import { Segment } from 'src/data/types/segments/types';
import { RulesDescriptor } from 'src/data/types/descriptor';

const project = useGlobalProject() || { UniqueCode: '' };

export default createController('/api/v1/segments/' + project.UniqueCode, {
    getAll: createControllerEndpoint<Segment[]>('GET', '/'),
    getById: createControllerEndpoint<Segment>('GET', '/{id}'),
    create: createControllerEndpoint<void>('POST', '/'),
    save: createControllerEndpoint<void>('PUT', '/{id}'),
    delete: createControllerEndpoint<void>('DELETE', '/{id}'),
    duplicate: createControllerEndpoint<void>('POST', '/{id}/duplicate'),
    test: createControllerEndpoint<RulesDescriptor>('POST', '/{id}/test'),
});